import { API_CONSTANT_MAP } from "./paths";
import requestApi from "./requestApi";

export type GetPagamentosPixFiltro = {
  conferido?: boolean;
  dataInicio?: string;
  dataFim?: string;
  unidadeIds?: number[];
  busca?: string;
};

export const getPagamentosPix = async (filtro?: GetPagamentosPixFiltro) => {
  const params = new URLSearchParams();
  if (filtro?.conferido !== undefined) params.append("conferido", String(filtro.conferido));
  if (filtro?.dataInicio) params.append("dataInicio", filtro.dataInicio);
  if (filtro?.dataFim) params.append("dataFim", filtro.dataFim);
  filtro?.unidadeIds?.forEach((u) => params.append("unidadeIds", String(u)));
  if (filtro?.busca) params.append("busca", filtro.busca);

  const query = params.toString();
  const url = query ? `${API_CONSTANT_MAP.pix}?${query}` : API_CONSTANT_MAP.pix;
  return requestApi.get(url);
};

export const conferirPagamentosPix = (ids: number[]) => {
  return requestApi.put(`${API_CONSTANT_MAP.pix}/conferir`, { ids });
};

export const anexarComprovantePix = (alunoPagamentoId: number, arquivo: File) => {
  const form = new FormData();
  form.append("arquivo", arquivo);
  return requestApi.postForm(`${API_CONSTANT_MAP.pix}/${alunoPagamentoId}/comprovante`, form);
};

/** Baixa o arquivo cru do comprovante (o corpo de erro também vem binário). */
export const baixarComprovantePix = (comprovanteId: number) => {
  return requestApi.get(`${API_CONSTANT_MAP.pix}/comprovante/${comprovanteId}`, true);
};

export const removerComprovantePix = (comprovanteId: number) => {
  return requestApi.delete(`${API_CONSTANT_MAP.pix}/comprovante/${comprovanteId}`);
};
